const { PUBLIC_SITE_URL } = process.env;

export function partnerStatus(partner) {
  if (partner.blocked) {
    return 'Blocked';
  }

  return 'Verified';
}

/**
 * @returns {string}
 */
export function getPartnerDirectoryURL() {
  return `${PUBLIC_SITE_URL.replace(/\/$/, '')}/partners`;
}

/**
 * Resolves whether or not the partner is listed: the public site serves an
 * unlisted profile by direct link so it can be previewed before approval.
 * @param {string} partnerId
 * @returns {string}
 */
export function getPartnerPageURL(partnerId) {
  return `${getPartnerDirectoryURL()}/${partnerId}`;
}

/**
 * The display label for what a partner can access on a store. Follows the
 * store's advanced (role-based) user permissions feature, not whichever
 * fields the connection happens to have: the role name with the feature
 * (no role means full access there), otherwise a full/custom permissions
 * summary based on `all_permissions`. Used the same way on the store's own
 * Partners/Partner pages and the partner dashboard's Stores page.
 * @param {{role_id?: string, role_name?: string, all_permissions?: boolean, permissions?: Array<string>}} connection
 * @param {boolean} isAdvancedUserPermissions
 * @returns {string | null}
 */
export function getPartnerAccessLabel(connection, isAdvancedUserPermissions) {
  if (isAdvancedUserPermissions) {
    if (connection.role_id) {
      return connection.role_name || null;
    }

    return 'Full permissions';
  }

  if (connection.all_permissions || !connection.permissions) {
    return 'Full permissions';
  }

  return 'Custom permissions';
}

/**
 * The partner dashboard path a store's partner invite moves on to after an Oath login
 * null when the login was not for a store invite.
 * @param {string} redirectTo The `to` the partner login was started with
 * @param {{session_id: string, partner_id: string}} session
 * @returns {string | null}
 */
export function getStoreInviteSelectPath(redirectTo, session) {
  if (!/^\/accept-store\/[^/?#]+$/.test(redirectTo || '')) {
    return null;
  }

  const query = new URLSearchParams({
    partner_id: session.partner_id,
    session_id: session.session_id,
  });

  return `${redirectTo}/select#${query.toString()}`;
}
